import firebase from 'firebase';
import React from 'react';
import { connect } from 'react-redux';
import { getCurrentAgeYears } from '../../calculations/userDataTransformer';
import UserApi from '../../firebase/UserApi';
import TableApi from '../../firebase/TableApi';
import { ErrorSplash } from '../error/ErrorScreen';
import LoadingScreen from './../LoadingScreen';
import CashFlowTables from './CashFlowTables';


const CashFlow = ({ peepAges }) => {
  let [retrievedData, setRetrievedData] = React.useState(undefined);
  let [error, setError] = React.useState(undefined);

  React.useEffect(() => {
    TableApi.getTableData().then(data => setRetrievedData(data)).catch(e => console.log(e) || setError(true));

    // async function getData() {
    //   try {
    //     const grabTableData = firebase.functions().httpsCallable('grabTableData');
    //     let data = await grabTableData({});
    //     setRetrievedData(data.data);
    //   } catch (e) {
    //     UserApi.crashReport("Crashed in Cashflow")
    //     setError(true);
    //   }
    // }
    // getData();
  }, []);

  if (error) {
    return <ErrorSplash />
  }

  if (!retrievedData) {
    return <LoadingScreen />
  }

  return (
    <div style={{ textAlign: "center", width: "100%", height: "100%" }}>
      <CashFlowTables cashFlowData={retrievedData} peepAges={peepAges} />
    </div>
  );
}

export default connect(state => {
  let peepAges = {
    [state.userData.answers.mainUserName]: {
      currentAge: getCurrentAgeYears(state.userData.answers.mainDob),
      currentYear: 2020,
    },
  }

  if (state.userData.answers.maritalStatus[0].id === 'married') {
    peepAges[state.userData.answers.spouseUserName] = {
      currentAge: getCurrentAgeYears(state.userData.answers.mainDob),
      currentYear: 2020,
    }
  }

  return {
    peepAges
  }
})(CashFlow); 